import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@carmato/car-market';

export const watchlistGuard: CanActivateFn = route => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.isUserLoggedIn()) {
    router.navigate([`dashboard/watchlist`]);
    return false;
  }
  return true;
};
